import { NotificationType } from './model/NotificationType';

export enum NotificationsGroupType {
  community,
  stories,
  healthJourney,
  companions,
  carepoints,
}

export const getNotificationGroupType = (notificationType: string) => {
  switch (notificationType) {
    case NotificationType.member_liked_a_post:
    case NotificationType.member_liked_a_reply:
    case NotificationType.member_replied_to_post:
    case NotificationType.member_replied_to_reply:
    case NotificationType.member_inserted_reply:
      return NotificationsGroupType.community;
    case NotificationType.membercommentedtostory:
    case NotificationType.membercommentedtostorycomment:
    case NotificationType.memberlikedastory:
    case NotificationType.memberlikedastorycomment:
    case NotificationType.memberpublishedstory:
      return NotificationsGroupType.stories;
    case NotificationType.journey_reminder:
      return NotificationsGroupType.healthJourney;
    case NotificationType.companion_request:
    case NotificationType.companion_request_answer:
    case NotificationType.pending_companion_request:
      return NotificationsGroupType.companions;
    case NotificationType.carepoint:
      return NotificationsGroupType.carepoints;
    default:
      return null;
  }
};
